export const SMARTPHONE_CATEGORY_ID = 2

export const DELIVERY_TIME = {
  standard: 0,
  plus1Day: 1,
  minus1Day: 2,
}
